import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createStore } from 'vuex'
import './assets/main.css'
import i18n from './i18n'

/* ---------- Theme bootstrap (run before app mounts) ---------- */
function getPreferredTheme() {
  const stored = localStorage.getItem('theme')
  if (stored) return stored
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}
function applyTheme(theme) {
  const root = document.documentElement
  if (theme === 'dark') root.classList.add('dark')
  else root.classList.remove('dark')
  localStorage.setItem('theme', theme)
}
applyTheme(getPreferredTheme())
/* ------------------------------------------------------------- */

const store = createStore({
  state() {
    return {
      user: null,
      isAuthCheckComplete: false
    }
  },
  mutations: {
    setUser(state, userData) {
      state.user = userData
    },
    clearUser(state) {
      state.user = null
    },
    setAuthCheckComplete(state, status) {
      state.isAuthCheckComplete = status
    }
  },
  actions: {
    async fetchUser({ commit }) {
      try {
        const res = await fetch(`/api/auth/users/me`, { credentials: 'include' })
        if (res.ok) {
          const userData = await res.json()
          commit('setUser', userData)
        } else {
          commit('setUser', null)
        }
      } catch (e) {
        console.error("Error fetching user:", e)
        commit('setUser', null)
      } finally {
        commit('setAuthCheckComplete', true)
      }
    },
    async logout({ commit }) {
      try {
        await fetch(`/api/auth/logout`, { method: 'POST', credentials: 'include' })
      } catch (e) {
        console.error("Error during logout:", e)
      } finally {
        commit('clearUser')
      }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  // Skip auth check for callback route only
  const skipAuthRoutes = ['/auth/callback']
  if (skipAuthRoutes.some(route => to.path.startsWith(route))) {
    return next()
  }

  if (!store.state.isAuthCheckComplete) {
    await store.dispatch('fetchUser')
  }

  const protectedRoutes = ['/']
  const isProtected = protectedRoutes.includes(to.path)
  const loggedIn = !!store.state.user

  // If logged in and trying to go to /login, redirect to /
  if (loggedIn && to.path === '/login') return next('/')

  if (isProtected && !loggedIn) return next('/login')

  next()
})

const app = createApp(App)
app.use(store)
app.use(router)
app.use(i18n)
app.mount('#app')
